"use client"

import { useReveal } from "@/components/marketing/landing-v2/useReveal"
import {
  buildWorkflowNodes,
  WorkflowRail,
} from "@/components/marketing/landing-v2/WorkflowRail"
import type { LandingCategoryId } from "@/lib/landing-v2/content"
import type { Landing2Copy } from "@/lib/landing-v2/copy"

export function WorkflowSection({
  copy,
  categoryId,
}: {
  copy: Landing2Copy
  categoryId: LandingCategoryId
}) {
  const ref = useReveal<HTMLElement>()
  const nodes = buildWorkflowNodes(copy, categoryId)

  return (
    <section className="l2-section" id="workflow">
      <div className="l2-container">
        <header className="l2-section-head" ref={ref}>
          <span className="l2-label">{copy.workflow.label}</span>
          <h2 className="l2-h2">{copy.workflow.title}</h2>
          <p className="l2-section-sub">{copy.workflow.subtitle}</p>
        </header>

        <div className="l2-canvas">
          <div className="l2-canvas-bar">
            <span className="l2-canvas-context">
              {copy.workflow.basedOn} <b>{copy.categories[categoryId].label}</b>
            </span>
            <span className="l2-status">
              <i />
              {copy.workflow.live}
            </span>
          </div>
          <WorkflowRail nodes={nodes} />
        </div>
      </div>
    </section>
  )
}
